// @flow

import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";

import List from "./List";
import { RelativeBox as StyledSearch } from "src/styles/box";

type Props = {
  focus: number,
  text: string,
  result: Array<number>,
  outerRef: any,
  handleClose: Function,
  setFocus: Function,
  handleSelect: Function,
};

type State = {
  focus: number,
};

class Result extends Component<Props, State> {
  state = {
    focus: 0,
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, true);
  }

  handleClickOutside = (e) => {
    const { outerRef, handleClose } = this.props;
    if (outerRef) {
      if (!outerRef.contains(e.target)) {
        handleClose();
      }
    }
  };

  handleKeyDown = (event: any) => {
    // Close Search when esc is pressed
    if (event.key === "Escape") {
      const { handleClose } = this.props;
      event.preventDefault();
      event.stopPropagation();
      handleClose();
    }

    if (event.keyCode === 38) {
      const { setFocus } = this.props;
      setFocus("up");
      event.preventDefault();
    }

    if (event.keyCode === 40) {
      const { setFocus } = this.props;
      setFocus("down");
      event.preventDefault();
    }
  };

  render() {
    const { text, focus, result, outerRef, handleSelect } = this.props;

    return (
      <StyledSearch>
        <List
          text={text}
          focus={focus}
          result={result}
          outerRef={outerRef}
          handleSelect={handleSelect}
        />
      </StyledSearch>
    );
  }
}

export default onClickOutside(Result);
